import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { WarningAmberRounded as WarningIcon } from '@mui/icons-material';

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isBusy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog = ({
  open,
  title = 'Confirmar cambio',
  message,
  confirmLabel = 'Continuar',
  cancelLabel = 'Cancelar',
  isBusy = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
      <DialogTitle
        sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}
      >
        <WarningIcon color='warning' fontSize='small' />
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isBusy} color='inherit'>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isBusy}
          variant='contained'
          color='warning'
        >
          {isBusy ? 'Guardando…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
